// Client mirror of functions-common/src/charts/datasets/time.ts. Keep in sync.

import type { DatasetDefinition } from '../types.js'

export const timeDataset: DatasetDefinition = {
  key: 'time',
  labelKey: 'NLSChartDatasetTime',
  fields: [
    { name: 'person', labelKey: 'NLSChartFieldPerson', kind: 'dimension', type: 'string' },
    { name: 'goal', labelKey: 'NLSChartFieldGoal', kind: 'dimension', type: 'string' },
    { name: 'task', labelKey: 'NLSChartFieldTask', kind: 'dimension', type: 'string' },
    { name: 'kind', labelKey: 'NLSChartFieldKind', kind: 'dimension', type: 'string' },
    { name: 'hours', labelKey: 'NLSChartFieldHours', kind: 'measure', type: 'number' },
    { name: 'day', labelKey: 'NLSChartFieldDay', kind: 'time', type: 'date' },
  ],
  defaultMeasure: { field: 'hours', agg: 'sum' },
  defaultTimeField: 'day',
  allowedRoles: ['OWNER', 'ADMIN', 'EDITOR', 'VIEWER'],
  available: false,
  unavailableReason: 'R19 timesheets have not landed in codebase',
}
